<add-card-to-deck-modal></add-card-to-deck-modal>
<div class="flex flex-col w-full shadow bg-slate-100 rounded-md text-md">
    <div id="card-name-holder" class="flex flex-col bg-ponder-light text-slate-50 rounded-t-md p-2 shadow">
        Decks with this Card
    </div>
    <div class="flex flex-col shadow-sm">
        @if (isLoading) {
            <busy-spin class="p-2"></busy-spin>
        } @else {
            @if (loadingSuccess) {
                @if (decksWithCard.length) {
                    <div class="w-full text-sm">
                        @for (deckWithCard of decksWithCard ; track deckWithCard.deckId) {
                            @if (isVisible(deckWithCard)) {
                                <magic-card-in-deck-row [username]="username" [deckWithCard]="deckWithCard" [thisCardId]="magicCard.id!"></magic-card-in-deck-row>
                            }
                        }
                    </div>
                    <!--
                    <div class="w-full">
                        <table class="table-auto w-full">
                            <thead class="text-left">
                                <tr>
                                    <th class="pl-2"></th>
                                    <th>Version</th>
                                    <th>Number</th>
                                    <th colspan="2">Count</th>
                                </tr>
                            </thead>
                            <tbody class="text-sm">
                                <div id="tooltip-holder" class="absolute">
                                    <div #versiontooltip role="tooltip" class="absolute z-50 inline-block w-[171px] h-[240px] shadow rounded-lg left-[-181px] bg-contain invisible"></div>
                                </div>
                                @for (deckWithCard of decksWithCard ; track deckWithCard.deckId) {
                                    @if (isVisible(deckWithCard)) {
                                        <tr (click)="onDeckClick(deckWithCard)" class="group hover:bg-ponder-linkhover hover:bg-opacity-25 border-t cursor-pointer">
                                            <td class="pl-2 font-bold" colspan="5">{{ deckWithCard.deckName }}</td>
                                        </tr>
                                        @for (layerWithCard of deckWithCard.layers ; track layerWithCard.layerName) {
                                            @for (matchingCard of layerWithCard.cards ; track matchingCard.itemId) {
                                                @if ((matchingCard.count + matchingCard.specialCount)) {
                                                    <tr 
                                                        (click)="onCardClick(matchingCard)"
                                                        (mouseenter)="onVersionHover(matchingCard)"
                                                        (mouseleave)="onVersionStopHover()"
                                                        class="group hover:bg-ponder-linkhover hover:bg-opacity-15 cursor-pointer"
                                                        [ngClass]="{'bg-ponder-linkhover bg-opacity-20' : isThisCard(matchingCard)}">
                                                        @if ($first) {
                                                            <td class="pl-2 pr-2">{{ layerWithCard.layerName }}</td>
                                                        } @else {
                                                            <td></td>
                                                        }
                                                        <td class="truncate max-w-[15ch] pr-1" [attr.title]="(matchingCard.setName.length > 15 ? matchingCard.setName : '')">{{ matchingCard.setName }}</td>
                                                        <td class="pr-1">#{{ matchingCard.setIndex }}</td>
                                                        <td class="text-center">@if (matchingCard.count) { {{ matchingCard.count }} }</td>
                                                        <td class="text-center text-foil-dark pr-2">@if (matchingCard.specialCount) { {{ matchingCard.specialCount }} }</td>
                                                    </tr>
                                                }
                                            }
                                        }
                                    }
                                }
                            </tbody>
                        </table>
                    </div>
                    -->
                } @else {
                    <div class="text-center p-2 gap-2 text-sm text-slate-400">
                        This card does not appear in any of your decks.
                    </div>
                }
                <button (click)="onAddVersionToDeckClick()" class="flex flex-row gap-2 p-1 pl-4 hover:bg-ponder-linkhover hover:bg-opacity-15 cursor-pointer text-sm rounded-b border-t">
                    <div>+</div>
                    <div>Add current version to a deck</div>
                </button>
            } @else {
                <generic-error></generic-error>
            }
        }
        <!--
        <div class="flex flex-col text-sm text-slate-400 p-2">
            This card is not in any of your decks.
        </div>
        -->
    </div>
</div>